import React from "react";
import {useSelector} from "react-redux";
import RootState from "../../../redux/states/root.state";
import {SpaSettingsLabels} from "../../../mqttData/settings/spaSettingsLabels";
import { SpecGroup, SpecRow, hasData } from "./SpecGroup";
import { isV1Spa } from "../../../hooks/useSpaCommand";

const NetworkCard: React.FC = () => {
    const settingsData = useSelector((state: RootState) => state.settings.data);
    const isV1 = useSelector((state: RootState) => isV1Spa(state.spa.data));
    const show = (value: unknown) => !isV1 || hasData(value);

    const signalMapper = (signal: any) => {
        if (signal<=-80){
            return 'Very Poor'
        } else if (signal<=-70 && signal>-80) {
            return 'Weak'
        } else if (signal<=-60 && signal>-70) {
            return 'Fair'
        } else if (signal<=-50 && signal>-60) {
            return 'Good'
        } else if (signal>-50){
            return 'Excellent'
        }
        return null
    }

    const signalTone = (signal: any) => signal > -60 ? 'good' : signal > -70 ? 'caution' : 'bad';

  const signal = settingsData[SpaSettingsLabels.Signal_Strength];
  const row = (label: string, key: string, mono?: boolean) => show(settingsData[key]) &&
    <SpecRow label={label} mono={mono}>{settingsData[key] ?? '-'}</SpecRow>;

  return (
    <section className="sd-section sd-spec-section sd-net">
      {/* Same groups and order as the original layout, side by side */}
      <div className="sd-specs sd-specs-row">
        <SpecGroup>
          {row('Eth/Wifi', SpaSettingsLabels.interface)}
        </SpecGroup>
        <SpecGroup>
          {row('Private IP', SpaSettingsLabels.Private_IP, true)}
          {row('Public IP', SpaSettingsLabels.Public_IP, true)}
          {row('MAC', SpaSettingsLabels.MAC_Address, true)}
        </SpecGroup>
        <SpecGroup>
          {row('SSID', SpaSettingsLabels.SSID)}
          {show(signal) && <SpecRow label="Signal Strength">
            {signal ?? '-'}
            {signal && signalMapper(signal) && <span className={`sd-pill ${signalTone(signal)}`}>{signalMapper(signal)}</span>}
          </SpecRow>}
          {row('Connection Type', SpaSettingsLabels.Connection_Type)}
        </SpecGroup>
        <SpecGroup>
          {row('Rx Packets', SpaSettingsLabels.stats_rx_packets)}
          {row('Tx Packets', SpaSettingsLabels.stats_tx_packets)}
        </SpecGroup>
        <SpecGroup>
          {row('Rx Errors', SpaSettingsLabels.stats_rx_errors)}
          {row('Tx Errors', SpaSettingsLabels.stats_tx_errors)}
        </SpecGroup>
        <SpecGroup>
          {row('Rx Dropped', SpaSettingsLabels.stats_rx_dropped)}
          {row('Tx Dropped', SpaSettingsLabels.stats_tx_dropped)}
        </SpecGroup>
        <SpecGroup>
          {row('Rx Bytes', SpaSettingsLabels.stats_rx_bytes)}
          {row('Tx Bytes', SpaSettingsLabels.stats_tx_bytes)}
        </SpecGroup>
        {show(settingsData?.storage_info) && <SpecGroup>
          <SpecRow label="Storage">{settingsData?.storage_info?.size ?? '-'}</SpecRow>
          <SpecRow label="Used">{`${settingsData?.storage_info?.used ?? '-'} (${settingsData?.storage_info?.use_percent ?? '-'})`}</SpecRow>
          <SpecRow label="Available">{settingsData?.storage_info?.available ?? '-'}</SpecRow>
        </SpecGroup>}
      </div>
    </section>
  );
};

export default NetworkCard;
